/* eslint-disable */
import React, { useState, useEffect, useCallback } from "react";
import { API_URL } from "../../config";
import moment from "moment";
import DateRangePicker from "react-bootstrap-daterangepicker";
import "bootstrap-daterangepicker/daterangepicker.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendarAlt, faDownload, faSync } from "@fortawesome/free-solid-svg-icons";
import { TrendingUp, Users, IndianRupee, Activity, CheckCircle, XCircle, AlertTriangle, Percent, Search } from "lucide-react";
import { PermissionWrapper } from "../../helpers/permission";
import UserImage from "../../assets/img/profile.png";

// Skeleton Loader Component
const ExecutivePerformanceSkeleton = () => (
    <div className="table-responsive">
        <table className="table border-0 mb-0">
            <thead>
                <tr className="bg-light bg-opacity-50">
                    <th className="border-0 rounded-start text-muted small fw-bold text-uppercase py-3 ps-4">User</th>
                    <th className="border-0 text-muted small fw-bold text-uppercase py-3">Executive</th>
                    <th className="border-0 text-center text-muted small fw-bold text-uppercase py-3">Leads</th>
                    <th className="border-0 text-center text-muted small fw-bold text-uppercase py-3">Contacted</th>
                    <th className="border-0 text-center text-muted small fw-bold text-uppercase py-3">Prospects</th>
                    <th className="border-0 text-center text-muted small fw-bold text-uppercase py-3">Conv.</th>
                    <th className="border-0 text-end text-muted small fw-bold text-uppercase py-3">Revenue</th>
                    <th className="border-0 text-end text-muted small fw-bold text-uppercase py-3">Rate/Client</th>
                    <th className="border-0 text-center text-muted small fw-bold text-uppercase py-3">Quality</th>
                    <th className="border-0 text-end text-muted small fw-bold text-uppercase py-3">Incentive</th>
                    <th className="border-0 text-end text-muted small fw-bold text-uppercase py-3">Final Inc.</th>
                    <th className="border-0 rounded-end text-center text-muted small fw-bold text-uppercase py-3 pe-4">Score</th>
                </tr>
            </thead>
            <tbody>
                {[1, 2, 3, 4, 5].map((idx) => (
                    <tr key={idx} className="border-bottom border-light">
                        <td className="ps-4 py-3"><div className="skeleton-card rounded-circle" style={{ width: '32px', height: '32px' }}></div></td>
                        <td className="py-3"><div className="skeleton-text" style={{ width: '120px', height: '16px' }}></div></td>
                        <td className="text-center py-3"><div className="skeleton-text" style={{ width: '30px', height: '16px', margin: '0 auto' }}></div></td>
                        <td className="text-center py-3"><div className="skeleton-text" style={{ width: '30px', height: '16px', margin: '0 auto' }}></div></td>
                        <td className="text-center py-3"><div className="skeleton-text" style={{ width: '40px', height: '16px', margin: '0 auto' }}></div></td>
                        <td className="text-center py-3"><div className="skeleton-text" style={{ width: '40px', height: '16px', margin: '0 auto' }}></div></td>
                        <td className="text-end py-3"><div className="skeleton-text" style={{ width: '60px', height: '16px', marginLeft: 'auto' }}></div></td>
                        <td className="text-end py-3"><div className="skeleton-text" style={{ width: '60px', height: '16px', marginLeft: 'auto' }}></div></td>
                        <td className="text-center py-3"><div className="skeleton-text" style={{ width: '30px', height: '16px', margin: '0 auto' }}></div></td>
                        <td className="text-end py-3"><div className="skeleton-text" style={{ width: '60px', height: '16px', marginLeft: 'auto' }}></div></td>
                        <td className="text-end py-3"><div className="skeleton-text" style={{ width: '60px', height: '16px', marginLeft: 'auto' }}></div></td>
                        <td className="pe-4 py-3"><div className="skeleton-rect w-100" style={{ height: '8px', borderRadius: '4px' }}></div></td>
                    </tr>
                ))}
            </tbody>
        </table>
    </div>
);




// Executive Performance Table Component (same as Dashboard)
const ExecutivePerformanceTable = ({ data, loading }) => {
    return (
        <div className="panel panel-default with-rounded-corner with-shadow mb-5">
            <div className="panel-heading">
                <div className="d-flex align-items-center gap-3">
                    <div className="p-2 rounded-4" style={{ background: 'linear-gradient(135deg, rgba(52, 143, 226, 0.1) 0%, rgba(52, 143, 226, 0.2) 100%)' }}>
                        <TrendingUp className="text-primary" size={20} />
                    </div>
                    <div>
                        <h4 className="mb-0 fw-bold text-dark" style={{ fontSize: '1.1rem' }}>Executive Performance</h4>
                        <span className="text-muted small">Daily performance metric breakdown</span>
                    </div>
                </div>
            </div>
            <div className="panel-body p-4">
                {loading ? <ExecutivePerformanceSkeleton /> : (
                    <div className="table-responsive">
                        <table className="table table-hover border-0 mb-0">
                            <thead>
                                <tr className="bg-light bg-opacity-50">
                                    <th className="border-0 rounded-start text-muted small fw-bold text-uppercase py-3 ps-4">User</th>
                                    <th className="border-0 text-muted small fw-bold text-uppercase py-3">Executive</th>
                                    <th className="border-0 text-center text-muted small fw-bold text-uppercase py-3">New Leads</th>
                                    <th className="border-0 text-center text-muted small fw-bold text-uppercase py-3">Contacted</th>
                                    <th className="border-0 text-center text-muted small fw-bold text-uppercase py-3">Prospects</th>
                                    <th className="border-0 text-center text-muted small fw-bold text-uppercase py-3">Conversions</th>
                                    <th className="border-0 text-end text-muted small fw-bold text-uppercase py-3">Revenue</th>
                                    <th className="border-0 text-end text-muted small fw-bold text-uppercase py-3">Rate/Client</th>
                                    <th className="border-0 text-center text-muted small fw-bold text-uppercase py-3">Quality</th>
                                    <th className="border-0 text-end text-muted small fw-bold text-uppercase py-3">Incentive</th>
                                    <th className="border-0 text-end text-muted small fw-bold text-uppercase py-3">Final Inc.</th>
                                    <th className="border-0 rounded-end text-center text-muted small fw-bold text-uppercase py-3 pe-4">Compl. Score</th>
                                </tr>

                            </thead>
                            <tbody>
                                {data && data.length > 0 ? (
                                    data.map((item, index) => (
                                        <tr key={index} className="align-middle border-bottom border-light hover-bg-light transition-all">
                                            <td className="py-3 ps-4">
                                                <img
                                                    src={item.executiveImage && item.executiveImage.trim() !== "" ? item.executiveImage : UserImage}
                                                    alt={item.executiveName}
                                                    className="rounded-circle shadow-sm border"
                                                    style={{ width: '32px', height: '32px', objectFit: 'cover' }}
                                                />
                                            </td>
                                            <td className="fw-semibold text-dark py-3">{item.executiveName}</td>
                                            <td className="text-center py-3">
                                                <span className="text-dark fw-medium">{item.newLeads}</span>
                                            </td>
                                            <td className="text-center py-3">
                                                <span className="text-muted">{item.contacted}</span>
                                            </td>
                                            <td className="text-center py-3">
                                                <span className="badge rounded-pill px-3" style={{ backgroundColor: 'rgba(52, 143, 226, 0.1)', color: '#348fe2' }}>
                                                    {item.prospectsCreated}
                                                </span>
                                            </td>
                                            <td className="text-center py-3">
                                                <span className="badge rounded-pill px-3" style={{ backgroundColor: 'rgba(16, 185, 129, 0.1)', color: '#10b981' }}>
                                                    {item.paidConversions}
                                                </span>
                                            </td>
                                            <td className="text-end py-3 fw-bold text-dark">₹{item.revenue.toLocaleString()}</td>
                                            <td className="text-end py-3 fw-bold text-dark">₹{(item.rate_Per_Client || 0).toLocaleString()}</td>
                                            <td className="text-center py-3">
                                                <span className="badge bg-white text-muted border">{item.qualityMultiplier || '1.0'}x</span>
                                            </td>
                                            <td className="text-end py-3 text-muted fw-semibold">₹{item.incentiveEarned.toLocaleString()}</td>
                                            <td className="text-end py-3 text-dark fw-bold">₹{(item.finalIncentive || 0).toLocaleString()}</td>

                                            <td className="text-center py-3 pe-4">
                                                <div className="d-flex align-items-center justify-content-center gap-2">
                                                    <div className="progress flex-grow-1" style={{ height: '6px', minWidth: '40px', maxWidth: '60px', borderRadius: '10px' }}>
                                                        <div className="progress-bar bg-info"
                                                            role="progressbar"
                                                            style={{ width: `${Math.min(item.complianceScore * 10, 100)}%` }}
                                                            aria-valuenow={item.complianceScore}
                                                            aria-valuemin="0"
                                                            aria-valuemax="10">
                                                        </div>
                                                    </div>
                                                    <span className="small text-muted fw-bold" style={{ fontSize: '0.75rem' }}>{item.complianceScore}</span>
                                                </div>
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="12" className="text-center py-5 text-muted">
                                            No executive performance records found.
                                        </td>
                                    </tr>

                                )}
                            </tbody>
                        </table>
                    </div>
                )}
            </div>
        </div>
    );
};

// Main Component
const ExecutivePerformanceReport = () => {
    const [performanceData, setPerformanceData] = useState(null);
    const [salesMetrics, setSalesMetrics] = useState(null);
    const [loading, setLoading] = useState(false);
    const [searchTerm, setSearchTerm] = useState("");
    const [dateRange, setDateRange] = useState({
        startDate: moment().subtract(6, "days"),
        endDate: moment(),
    });
    const { startDate, endDate } = dateRange;

    const ranges = {
        "Today": [moment(), moment()],
        "Yesterday": [moment().subtract(1, "days"), moment().subtract(1, "days")],
        "Last 7 Days": [moment().subtract(6, "days"), moment()],
        "Last 30 Days": [moment().subtract(29, "days"), moment()],
        "This Month": [moment().startOf("month"), moment().endOf("month")],
        "Last Month": [
            moment().subtract(1, "month").startOf("month"),
            moment().subtract(1, "month").endOf("month"),
        ],
    };

    const formatDate = (date) => {
        if (!date) return "";
        return date.format("YYYY-MM-DD");
    };

    const getQueryParams = () => {
        if (startDate && endDate) {
            return `?startDate=${formatDate(startDate)}&endDate=${formatDate(endDate)}`;
        }
        return "";
    };



    const fetchData = useCallback(async () => {
        try {
            setLoading(true);
            const token = localStorage.getItem("authToken");
            const query = getQueryParams();

            // Fetch both sales metrics and executive performance
            const [performanceRes, metricsRes] = await Promise.all([
                fetch(`${API_URL}executive-report/stats-executive-performance${query}`, {
                    headers: { Authorization: `Bearer ${token}`, Accept: "*/*" },
                }),
                fetch(`${API_URL}user-dashboard/sales-metrics${query}`, {
                    headers: { Authorization: `Bearer ${token}`, Accept: "*/*" },
                })
            ]);

            const performanceData = await performanceRes.json();
            const metricsData = await metricsRes.json();

            if (performanceData && performanceData.success) {
                const enrichedData = (performanceData.data || []).map(item => ({
                    ...item,
                    rate_Per_Client: item.rate_Per_Client || 0,
                    qualityMultiplier: item.qualityMultiplier || 1.0,
                    finalIncentive: item.finalIncentive || item.incentiveEarned || 0
                }));
                setPerformanceData(enrichedData);
            } else {
                setPerformanceData([]);
            }


            if (metricsData && metricsData.success) {
                setSalesMetrics(metricsData.data || {});
            } else {
                setSalesMetrics({});
            }
        } catch (err) {
            console.error("Failed to fetch executive performance report", err);
            setPerformanceData([]);
            setSalesMetrics({});
        } finally {
            setLoading(false);
        }
    }, [startDate, endDate]);

    useEffect(() => {
        fetchData();
    }, [fetchData]);

    const handleApply = (event, picker) => {
        setDateRange({
            startDate: picker.startDate,
            endDate: picker.endDate,
        });
    };

    const handleExport = () => {
        if (!performanceData || performanceData.length === 0) return;

        const headers = ["Executive", "New Leads", "Contacted", "Prospects Created", "Paid Conversions", "Revenue", "Rate/Client (₹)", "Quality Multiplier", "Incentive Earned", "Final Incentive", "Compliance Score"];
        const csvData = performanceData.map(item => [
            item.executiveName,
            item.newLeads,
            item.contacted,
            item.prospectsCreated,
            item.paidConversions,
            item.revenue,
            item.rate_Per_Client,
            item.qualityMultiplier,
            item.incentiveEarned,
            item.finalIncentive,
            item.complianceScore
        ]);


        let csvContent = headers.join(",") + "\n" + csvData.map(e => e.join(",")).join("\n");
        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.setAttribute("href", url);
        link.setAttribute("download", `Executive_Performance_Report_${moment().format('YYYY-MM-DD')}.csv`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    const filteredData = performanceData ? performanceData.filter(item =>
        item.executiveName.toLowerCase().includes(searchTerm.toLowerCase())
    ) : null;

    return (
        <div className="page-header-fixed page-sidebar-fixed fade in mt-5">
            {/* Header with Date Filter */}
            <PermissionWrapper module="dashboard" action="view">
                <div className="d-flex justify-content-between align-items-center mb-4">
                    <h1 className="page-header mb-0">
                        Executive Performance Report <small>Detailed Analysis</small>
                    </h1>
                    <div className="d-flex gap-2 align-items-center">
                        <DateRangePicker
                            initialSettings={{
                                ranges: ranges,
                                startDate: startDate || moment(),
                                endDate: endDate || moment(),
                                locale: { format: "DD-MM-YYYY" },
                            }}
                            onApply={handleApply}
                        >
                            <div className="input-group" style={{ cursor: 'pointer', width: '240px' }}>
                                <input
                                    type="text"
                                    className="form-control"
                                    value={startDate && endDate ? `${startDate.format("DD-MM-YYYY")} - ${endDate.format("DD-MM-YYYY")}` : 'Select Date Range'}
                                    readOnly
                                    style={{ background: '#fff', cursor: 'pointer' }}
                                />
                                <span className="input-group-text bg-light">
                                    <FontAwesomeIcon icon={faCalendarAlt} />
                                </span>
                            </div>
                        </DateRangePicker>

                        <div className="input-group" style={{ width: '240px' }}>
                            <span className="input-group-text bg-white border-end-0">
                                <Search size={16} className="text-muted" />
                            </span>
                            <input
                                type="text"
                                className="form-control border-start-0 ps-0"
                                placeholder="Search executive..."
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                            />
                        </div>
                        {/* <button
                            onClick={fetchData}
                            className="btn btn-white border shadow-sm px-3 bg-white"
                            disabled={loading}
                        >
                            <FontAwesomeIcon
                                icon={faSync}
                                className={loading ? 'fa-spin text-primary' : 'text-muted'}
                            />
                        </button>
                        <button
                            onClick={handleExport}
                            disabled={!performanceData?.length}
                            className="btn btn-primary shadow-sm px-3 d-flex align-items-center gap-2"
                        >
                            <FontAwesomeIcon icon={faDownload} />
                            <span className="fw-bold">Export</span>
                        </button> */}
                    </div>
                </div>
            </PermissionWrapper >



            {/* Executive Performance Table */}
            < PermissionWrapper module="dashboard_executive_performance" action="view" >
                <div className="row mb-5">
                    <div className="col-12">
                        <ExecutivePerformanceTable data={filteredData} loading={loading} />
                    </div>
                </div>
            </PermissionWrapper >
        </div >
    );
};

export default ExecutivePerformanceReport;